const comprehensions = [
  "BACKEND DEV",
  "ALGORITHMS",
  "DATA STRUCTURES",
  "DESIGN PATTERNS",
  "DATABASES",
  "AI & DS",
];

export default comprehensions;
